module.exports = __webpack_public_path__ + "img/input-latin-lowercase.6910e457.png";